<template>
  <Header />
  <RevisionBrowser title="Revisions" :revisions="revisions" :loading="loading" :error="error"
    @refresh="fetchRevisions" />
</template>

<script>
import Header from './Header.vue';
import axios from 'axios';
import RevisionBrowser from './RevisionBrowser.vue';

// Revision types that are never shown on this page
const EXCLUDED_TYPES = [];

export default {
  name: 'ViewRevisions',
  components: {
    Header,
    RevisionBrowser,
  },

  data() {
    return {
      revisions: [],
      loading: true,
      error: '',
    };
  },

  mounted() {
    this.fetchRevisions();
  },

  methods: {
    async fetchRevisions() {
      this.loading = true;
      this.error = '';
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        const result = await axios.get('/api/revisions', { headers });
        this.revisions = (result.data || []).filter(r => !EXCLUDED_TYPES.includes(r.revisionable_type));
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
        this.error = 'Revisions could not be loaded. Please try again.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
